import Skeleton from 'react-loading-skeleton'
import { StyledIntakeCard } from './IntakeCard'

export const IntakeItemSkeleton = ({ type }: { type?: 'short' | 'detailed' | 'compact' }) => {
  return (
    <StyledIntakeCard type={type}>
      <div className="intake-header">
        <Skeleton
          height={'30px'}
          width={'75%'}
        />
      </div>
      <div className="intake-details">
        <Skeleton
          height="25px"
          width={'40%'}
        />
        <Skeleton
          height="55px"
          width={'80%'}
          style={{ margin: '10px 0' }}
        />
        <Skeleton
          height="25px"
          width={'30%'}
        />
      </div>
      {type === 'compact' && (
        <div className="button-panel">
          <Skeleton
            height="35px"
            width="70%"
            style={{ margin: '10px 0' }}
          />
          <Skeleton
            height="50px"
            width="90%"
            style={{ margin: '10px 0' }}
          />
        </div>
      )}
    </StyledIntakeCard>
  )
}
